import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function Base64Calc() {
  const [mode, setMode] = useState('encode');
  const [text, setText] = useState('Hello, world!');
  const [encoded, setEncoded] = useState('');
  const [fileB64, setFileB64] = useState('');
  const [fileName, setFileName] = useState('');

  const run = () => {
    try {
      if (mode === 'encode') setEncoded(btoa(unescape(encodeURIComponent(text))));
      else setEncoded(decodeURIComponent(escape(atob(text))));
    } catch (e) { setEncoded('Error: ' + e.message); }
  };

  const onFile = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setFileName(f.name);
    const r = new FileReader();
    r.onload = () => setFileB64(String(r.result));
    r.readAsDataURL(f);
  };

  return (
    <CalcShell look="cnet" title="Base64 Encoder / Decoder" subtitle="Encode text or files to Base64, or decode Base64 back to text.">
      <div className="flex gap-2 border-b mb-4">
        {[['encode','Encode'],['decode','Decode'],['file','Encode File / Image']].map(([v,l]) => (
          <button key={v} className={`px-4 py-2 text-sm font-semibold ${mode===v?'border-b-2 border-blue-600 text-blue-700':'text-slate-500'}`} onClick={() => setMode(v)}>{l}</button>
        ))}
      </div>
      {mode !== 'file' ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <div className="field"><label>{mode === 'encode' ? 'Text' : 'Base64 String'}</label>
              <textarea rows={8} value={text} onChange={e => setText(e.target.value)} className="w-full" data-testid="b64-input"/>
            </div>
            <button onClick={run} className="px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700" data-testid="b64-run">Run</button>
          </div>
          <div>
            <div className="field"><label>Output</label>
              <textarea rows={8} value={encoded} readOnly className="w-full font-mono text-sm" data-testid="b64-output"/>
            </div>
            <button onClick={() => navigator.clipboard.writeText(encoded)} className="px-4 py-2 border rounded-lg">Copy</button>
          </div>
        </div>
      ) : (
        <div>
          <input type="file" onChange={onFile}/>
          {fileName && <p className="mt-2 text-sm">Loaded: <b>{fileName}</b></p>}
          {fileB64 && (
            <>
              <textarea rows={8} value={fileB64} readOnly className="w-full mt-3 font-mono text-xs"/>
              {fileB64.startsWith('data:image') && <img src={fileB64} alt="preview" className="mt-3 max-w-xs rounded border"/>}
            </>
          )}
        </div>
      )}
    </CalcShell>
  );
}
